import { IComponentName, IPage } from '../../interfaces';

const sortComponentItems: Array<IComponentName | string> = [
    // main
    '0000.02-Separator',
    'My',
    'Profile',
    'MyCompany',
    'MyAlarms',
    'MonthlyUsageList',
    // SupportPage
    'SupportPage',
    'UploadCardDevice',
    'HashCompaniesInfo',
    'FeatureFlags',
    'GatewayConfig',
    'ScpFileUpload',
    'ImpersonateUser',
    'ExternalAPIList',
    'ESPlusNotifications',
    'ESPlusNotificationsLogs',
    'ESPlusNotificationQRcodes',
    'OperatorInteractionsFilesList',
    'OperatorInteractionsResponsesList',
    'DataImport',
    // OCS
    '0000.99-Separator',
    'Dashboard',
    'UsersList',
    'CompaniesList',
    '0004.9-Separator',
    'CardSetsList',
    'CardList',
    'CallDataRecordsList',
    'CallDataRecordsListBeta',
    'BalanceLogList',
    'ActivityLogList',
    'PackagesUnitsLogsList',
    // 'PaperTrailLogsList',
    'Finances',
    'TariffPackageInstancesList',
    'TariffPackageInstanceView',
    'Tariff',
    'TariffsList',
    'TariffsPackagesList',
    'TariffBuy',
    'TariffToBuyList',
    'TariffPackagesToBuyList',
    'Packages',
    'PackagesBuy',
    'PackagesSell',
    '0009.9-Separator',
    'GeoTracking',
    'OperatorsList',
    'SalesRateLists',
    'SalesRateListsV2',
    'PurchaseRatesList',
    'OrdersList',
    '0015.9-Separator',
    'ZonesList',
    'CountryList',
    'CurrenciesList',
    'SubscribersList',
    'DiameterSessionsList',
    'ReportsPageList',
    '0022.9-Separator',
    // billing
    '0003.01-Separator',
    'BillingMockMainPage',
    // main
    'About',
];

const getListIndex = (str: string): number => {
    const index = sortComponentItems.indexOf(str);
    if (index === -1) {
        return 99999;
    }
    return index;
};

const getMenuIndex = (p: IPage): number => {
    if (p.componentName === 'Separator') {
        return getListIndex(p.id);
    }
    return getListIndex(p.componentName);
};

export const sortMenu = (pages: IPage[]): IPage[] => {
    return pages.map((i: IPage) => ({
        ...i,
        menuOrder: getMenuIndex(i),
        subMenu: i.subMenu && i.subMenu.length ? sortMenu(i.subMenu) : undefined,
    }));
};
